import { AppSettings } from "./interfaces/App-Settings";

// will be replaced in azure devops release pipe line
const appSettings : AppSettings = {
    apiPath: "#{apiPath}#"
}

export default appSettings;